export default __webpack_public_path__ + "static/data-vis-adjacent-color-do-light-7438ab49f9252add7e00a3a3997f85b76ae65ec5276e202f56dcf3dc57e9e041.png";